import { apiUrl } from "../../../settings"

export const UpdatesUrl = () => {
  return apiUrl + '/updates'
}

export const deleteUpdatesUrl = (id) => {
  return apiUrl + '/updates/' + id
}
